import { apiClient, ApiClient } from "@/lib/api/api-client";
import { EmployeeInfo } from "@/modules/types/employee/employee";
import { BaseResponse } from "@/modules/types/response";

interface EmployeeResp extends BaseResponse {
  employeeInfo: EmployeeInfo;
}

export class EmployeeService {
  private BASE_PATH =
    process.env.API_EMPLOYEEE_ENDPOINT || "http://localhost:8081/employee";
  private apiClient: ApiClient = apiClient;
  private apiVersion = "v1.0.0";
  constructor(apiVersion?: string) {
    this.apiVersion = apiVersion || this.apiVersion;
  }

  async getByDefault(): Promise<EmployeeResp | undefined> {
    return this.apiClient.fetch<EmployeeResp>(
      `${this.BASE_PATH}/${this.apiVersion}/information`,
    );
  }
}

export const employeeService = new EmployeeService();
